import { Option, Select } from "@simplybusiness/mobius";
import type { QuestionComponentProps } from "../../types";

export const SelectQuestion = ({
  options,
  questionFieldProps,
}: QuestionComponentProps) => {
  const { placeholder, value, questionLabelProps, helpInfo, ...otherProps } =
    questionFieldProps;

  if (!options?.length) {
    console.warn(`No required options found`);
    return null;
  }

  // If a placeholder is provided, add it as the first option
  const displayOptions = placeholder
    ? [{ label: placeholder, value: "" }, ...options]
    : options;

  return (
    <Select {...otherProps} value={value as string}>
      {displayOptions.map(option => (
        <Option key={option.value} value={option.value}>
          {option.label}
        </Option>
      ))}
    </Select>
  );
};
